import { render, staticRenderFns } from "./VolumeArchive.vue?vue&type=template&id=f4dc8b64&scoped=true&"
import script from "./VolumeArchive.vue?vue&type=script&lang=js&"
export * from "./VolumeArchive.vue?vue&type=script&lang=js&"
import style0 from "./VolumeArchive.vue?vue&type=style&index=0&id=f4dc8b64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dc8b64",
  null
  
)

export default component.exports